<template>
  <div>
    <forgot-password-form />
  </div>
</template>

<script>
import ForgotPasswordForm from "../components/auth/ForgotPasswordForm";

export default {
  name: "forgot",
  data() {
    return {};
  },
  methods: {},
  components: {
    ForgotPasswordForm,
  },
};
</script>

<!-- styling for the component -->
<style scoped></style>
